import React from "react";
import Navbar from "../components/LandingPageNew/Navbar";
import HeroSection from "../components/CRMAutomation/HeroSection";
import Benefits from "../components/CRMAutomation/Benefits";
import NoCRMProblem from "../components/CRMAutomation/NoCRMProblem";
import Features from "../components/CRMAutomation/Features";
import OurProccess from "../components/CRMAutomation/OurProccess";
import Footer from "../components/LandingPageNew/Footer";
import SEO from "../components/Shared/SEO";
import PainPoints from '../components/CRMAutomation/PainPoints';
import WasSieKonkretGewinnen from "../components/CRMAutomation/WasSieKonkretGewinnen";
import Faq from "../components/LandingPageNew/Faq";
import Trust from "../components/CRMAutomation/Trust";
import Who from "../components/CRMAutomation/Who";
const CrmAutomation = () => {
  const tabs = [
    { id: "general", label: "Allgemein" },
    { id: "process", label: "Prozess" },
    { id: "support", label: "Support" },
  ];
  const faqData = {
    general: [
      {
        question: "Wie schnell ist eine KI-Automatisierung einsatzbereit?",
        answer:
          " ",
      },
       {
        question: "Ist das DSGVO-konform?",
        answer:
          " ",
      },
       {
        question: "Was kostet eine KI-Automatisierung?",
        answer:
          " ",
      },
       {
        question: "Können bestehende Tools integriert werden?",
        answer:
          " ",
      },

    ]
  };
  return (
    <>
      <SEO
        title="KI-Automatisierung – Effizientere Prozesse mit KI"
        description="Intelligente KI-Automatisierungen für Unternehmen. Wiederkehrende Prozesse 
automatisieren, Zeit sparen und effizienter arbeiten. "
        canonical="https://uneva.de/ki-automatisierung-prozesse"
      />
      <Navbar />
      {/* <HeroSection /> */}
      {/* <Benefits /> */}
      
      <NoCRMProblem />
      <PainPoints/>
      <OurProccess />
      <Features />
      <WasSieKonkretGewinnen />
      <Who/>
      <Trust/>
      <Faq
              title={
                <>
                 Häufige Fragen   <span className="text-[#0b2b40]">zur</span> KI-Automatisierung
                </>
              }
              subtitle=""
              tabs={tabs}
              faqData={faqData}
              defaultTab="general"
            />
      <Footer />
    </>
  );
};
export default CrmAutomation;
